import { ResultsActions } from './../session/results.actions';
import { DiagnosticsActions } from './diagnostics.actions';
import { IPayloadAction } from './../session/session.actions';
import { IDiagnostics } from '../interfaces';

export function diagnosticsReducer(diagnostics: IDiagnostics, action: IPayloadAction) {
  switch (action.type) {
    case ResultsActions.DIAGNOSTIC_RESULTS_RECEIVED:
      return {
        ...diagnostics,
        results: {
          ...diagnostics.results,
          [action.payload.sessionId]: action.payload.results,
        },
      };

    case DiagnosticsActions.DIAGNOSTICS_DEBUG_IMAGE_URLS_RECEIVED:
      return { ...diagnostics, debugUrls: action.payload };

    default:
      return diagnostics;
  }
}
